import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { filtersChangeCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { searchFiltersState } from 'Pages/RecipientsList/recoil/state/filters'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { FormElement, Grid, GridCell, InputText } from 'mailup-web-components'

const InputContact: FC = () => {
  const intl = useIntl()

  const { contact } = useRecoilValue(searchFiltersState)

  const filtersChange = useRecoilCallback(filtersChangeCallback, [])

  const handleContactChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>): void => {
    void filtersChange('contact', value)
  }

  return (
    <Grid cols={12}>
      <GridCell span={6}>
        <FormElement>
          <InputText
            value={contact.value}
            onChange={handleContactChange}
            placeholder={intl.formatMessage({
              id: 'Load.RecipientsList.SearchContactPlaceholder',
            })}
            data-mu-test="filters-contact"
          />
        </FormElement>
      </GridCell>
    </Grid>
  )
}

export default InputContact
